import { addNewUserSuccess, addNewUserFail,
  getAllSupervisorsSuccess, getAllSupervisorsFail,
  deleteExistingUserSuccess, deleteExistingUserFail,
  editExistingUserFail, editExistingUserSuccess
} from "../constants/supervisor";

const initialState = {
isProcessing: false,
isError: false,
data: []
}

const handleReducer = (state, action) => {
switch(action.type) {

  case getAllSupervisorsSuccess:
    return {...state, data: action.payload};

  case getAllSupervisorsFail:
    return {...state, isError: true};

  case addNewUserSuccess:
    return {...state, data: [...state.data, action.payload]};

  case addNewUserFail:
    return { ...state, isError: true};

  case deleteExistingUserSuccess:
    return { ...state, data: state.data.filter(user => user.supervisorId !== action.payload) };

  case deleteExistingUserFail:
    return { ...state, isError: true };

  case editExistingUserSuccess:
    return {
      ...state,
      data: state.data.map(user =>
        user.supervisorId === action.payload.supervisorId ? { ...user, ...action.payload } : user
      )
    };

  case editExistingUserFail:
    return { ...state, isError: true };

  default:
  return state;
}
}

export const supervisorReducer = (state = initialState, action = {}) => {
return handleReducer(state, action);
}
